import {
    SiReact, SiTypescript, SiMysql, SiMongodb, SiExpress, SiTailwindcss,
    SiNextdotjs, SiBootstrap, SiNodedotjs, SiPython, SiGit, SiHtml5,
    SiCss3, SiOpenai, SiGooglegemini, SiJsonwebtokens, SiChakraui
} from 'react-icons/si';

const SKILLS = [
    { name: "React", Icon: SiReact },
    { name: "Next.js", Icon: SiNextdotjs },
    { name: "TypeScript", Icon: SiTypescript },
    { name: "Node.js", Icon: SiNodedotjs },
    { name: "MongoDB", Icon: SiMongodb },
    { name: "Express", Icon: SiExpress },
    { name: "MySQL", Icon: SiMysql },
    { name: "Tailwind CSS", Icon: SiTailwindcss },
    { name: "Bootstrap", Icon: SiBootstrap },
    { name: "Python", Icon: SiPython },
    { name: "Git", Icon: SiGit },
    { name: "HTML5", Icon: SiHtml5 },
    { name: "CSS3", Icon: SiCss3 },
    { name: "OpenAI", Icon: SiOpenai },
    { name: "Google Gemini", Icon: SiGooglegemini },
    { name: "JWT", Icon: SiJsonwebtokens },
    { name: "Chakra UI", Icon: SiChakraui },
];

export const Skills = () => {
    return (
        <section id="skills" className="py-16 overflow-hidden" aria-label="Skills and Technologies">
            <div className="relative w-full overflow-hidden [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-128px),transparent_100%)]">
                <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
                    <div className="flex items-center gap-10 pr-10">
                        {SKILLS.map(({ name, Icon }) => (
                            <div
                                key={name}
                                className="flex flex-col items-center justify-center min-w-[90px] h-[90px] group transition-transform hover:scale-110"
                                title={name}
                            >
                                <Icon
                                    size="2.6em"
                                    className="text-blue-400 group-hover:text-blue-300 transition-colors"
                                    aria-label={name}
                                    role="img"
                                />
                                <span className="text-xs text-slate-400 mt-2 opacity-0 group-hover:opacity-100 transition-opacity">
                                    {name}
                                </span>
                            </div>
                        ))}
                    </div>

                    <div className="flex items-center gap-10 pr-10" aria-hidden="true">
                        {SKILLS.map(({ name, Icon }, index) => (
                            <div
                                key={`${name}-duplicate-${index}`}
                                className="flex flex-col items-center justify-center min-w-[90px] h-[90px] group transition-transform hover:scale-110"
                            >
                                <Icon
                                    size="2.6em"
                                    className="text-blue-400 group-hover:text-blue-300 transition-colors"
                                />
                                <span className="text-xs text-slate-400 mt-2 opacity-0 group-hover:opacity-100 transition-opacity">
                                    {name}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};